import { i as y, x as r, s as m } from "../../../lit-element-6iugfgmM.js";
import { e as g } from "../../../custom-element-wk-AooBb.js";
import { n as l } from "../../../property-BWlAHqg_.js";
import { t as d } from "../../../state-STZTbIJp.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import { o as b } from "../../../if-defined-D-RhGngI.js";
import { Analytics as k } from "../../../lib/Analytics.js";
import { isTest as u } from "../../../lib/Environment.js";
import { Localize as w } from "../../../lib/I18N.js";
import "../../../sp-action-button-CjSKZ-qO.js";
import "../../../sp-button-fa52iiKJ.js";
import "../../../sp-dialog-C9swJ4nV.js";
import "../../../sp-dialog-base-CHozb5nU.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-checkmark.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-info-outline.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-link.js";
import "../../../sp-link-Bvw83YuP.js";
import "../../../sp-switch-C-kKr_HU.js";
import "../../../sp-tooltip-RAJ82M3n.js";
import { g as v, l as f, m as _, n as I, o as C, u as S } from "../../../Libraries-BoeFPC98.js";
import $ from "../../../events/DeletePublicLibraryUrlEvent.js";
import c from "../../../events/NotificationEvent.js";
import L from "../../../events/SavePublicLibraryUrlEvent.js";
import D from "../../../events/FetchSharedLibraryBookmarkEvent.js";
const x = { "share-library-dialog.heading": "Share ‘{name}’", "share-library-dialog.copy-link": "Copy link", "share-library-dialog.link-help": "Anyone with the link can view and share the library.", "share-library-dialog.toggle-save-copy": "Allow to save a copy", "share-library-dialog.toggle-follow": "Allow to follow", "share-library-dialog.all-contents": "all contents", "share-library-dialog.save-copy-tooltip": "Allow any Creative Cloud user with this link to save a copy of the library to their account. Changes they make to their copy will not affect your original library.", "share-library-dialog.follow-tooltip": "Allow any Creative Cloud user with this link to follow your library and see updates you make to it.", "share-library-dialog.remove-link": "Remove link", "share-library-dialog.error-message": "Failed to copy link", "share-library-dialog.success-message": "Link copied", "share-library-dialog.removal-error-message": "Failed to remove link", "share-library-dialog.removal-success-message": "Link removed", "share-library-dialog.update-error-message": "Failed to update sharing settings", "share-library-dialog.update-success-message": "Updated sharing settings" }, E = y`.container{align-items:center;display:flex}.copy-button{width:100%}.help-text{font-size:13px}.remove-link-container{margin-top:-8px}.remove-success-message{align-items:center;display:flex}sp-icon-checkmark{color:var(--spectrum-global-color-green-400);margin-right:5px}sp-link{padding-left:5px;text-decoration:underline;text-decoration-color:var(--spectrum-link-text-color-primary-default)}.switch-tooltip{margin:-10px 0 0 -13px;padding:0}.switch-tooltip:focus,.switch-tooltip:hover{background:none}.tooltip-button{width:10px}`;
var A = Object.defineProperty, P = Object.getOwnPropertyDescriptor, s = (i, t, n, a) => {
  for (var h, o = a > 1 ? void 0 : a ? P(t, n) : t, p = i.length - 1; p >= 0; p--) (h = i[p]) && (o = (a ? h(t, n, o) : h(o)) || o);
  return a && o && A(t, n, o), o;
};
let e = class extends k(w(m, x)) {
  constructor() {
    super(...arguments), this.open = !1, this.libraryIdOrUrn = "", this.libraryName = "", this.storagePath = "", this.copyDisabled = !1, this.followDisabled = !1, this.bookmarkId = null, this.creatorId = "", this.showLinkRemovalMessage = !1, this.pending = !1, this._handleCopySwitchClick = () => {
      this.copyDisabled = !this.copyDisabled, this._updateLinkSettings().catch(() => {
        this.copyDisabled = !this.copyDisabled;
      });
    }, this._handleFollowSwitchClick = () => {
      this.followDisabled = !this.followDisabled, this._updateLinkSettings().catch(() => {
        this.followDisabled = !this.followDisabled;
      });
    };
  }
  static get styles() {
    return E;
  }
  connectedCallback() {
    super.connectedCallback(), this._fetchSharedLibraryBookmark();
  }
  render() {
    return r`<sp-dialog-base .open="${this.open}" @close="${this._handleClose}" underlay dismissable><sp-dialog size="m" dismissable><span slot="heading">${this.t("share-library-dialog.heading", { name: this.libraryName })}</span> ${this.renderDialogContent()}</sp-dialog></sp-dialog-base>`;
  }
  renderDialogContent() {
    return this.showLinkRemovalMessage && this.bookmarkId == null ? this._renderRemoveSuccess() : r`<sp-button class="copy-button" @click="${this._handleCopyLink}" ?pending="${this.pending}"><sp-icon-link slot="icon"></sp-icon-link>${this.t("share-library-dialog.copy-link")}</sp-button><div class="remove-link-container"><p class="help-text">${this.t("share-library-dialog.link-help")}${this.renderRemoveLink()}</p></div>${this.renderSaveCopySwitch()} ${this.renderFollowSwitch()}`;
  }
  renderRemoveLink() {
    const i = r`<sp-link tabIndex="0" @click="${this._removeCopyLink}" target="_blank">${this.t("share-library-dialog.remove-link")}</sp-link>`;
    if (this.bookmarkId) return r`${i}`;
  }
  _renderRemoveSuccess() {
    return r`<div class="remove-success-message"><sp-icon-checkmark></sp-icon-checkmark>${this.t("share-library-dialog.removal-success-message")}</div>`;
  }
  renderSaveCopySwitch() {
    const i = v(this.libraryIdOrUrn), t = r`<sp-link @click="${this._handleLinkClick}" href="${i}" target="_blank">${this.t("share-library-dialog.all-contents")}</sp-link>`;
    return r`<div class="container"><sp-switch emphasized checked="${b(!this.copyDisabled || void 0)}" @click="${this._handleCopySwitchClick}"><span>${this.t("share-library-dialog.toggle-save-copy", { link: t })}</span></sp-switch>${this.renderTooltip(this.t("share-library-dialog.save-copy-tooltip"))}</div>`;
  }
  _handleClose() {
    this.open = !1, this.dispatchEvent(new Event("close", { bubbles: !0, composed: !0 }));
  }
  renderFollowSwitch() {
    return r`<div class="container"><sp-switch emphasized checked="${b(!this.followDisabled || void 0)}" label="${this.t("share-library-dialog.toggle-follow")}" @click="${this._handleFollowSwitchClick}"><span>${this.t("share-library-dialog.toggle-follow")}</span></sp-switch>${this.renderTooltip(this.t("share-library-dialog.follow-tooltip"))}</div>`;
  }
  renderTooltip(i) {
    return r`<sp-action-button size="xs" label="${i}" quiet class="switch-tooltip"><sp-icon-info-outline slot="icon" class="tooltip-button"></sp-icon-info-outline><sp-tooltip self-managed>${i}</sp-tooltip></sp-action-button>`;
  }
  _handleLinkClick(i) {
    i.stopPropagation();
  }
  _dispatchSuccessfulUpdateEvents() {
    this._dispatchSavePublicLibraryUrlEvent(), this.dispatchSuccessNotification(this.t("share-library-dialog.update-success-message"));
  }
  _fetchSharedLibraryBookmark() {
    this.dispatchEvent(new D({ libraryId: this.libraryIdOrUrn, callback: (i, t, n) => {
      this.bookmarkId = i, this.copyDisabled = !t, this.followDisabled = !n;
    } }));
  }
  _sendCopyLinkAnalytics() {
    const i = { copyDisabled: this.copyDisabled, followDisabled: this.followDisabled, repeatCopy: !!this.bookmarkId };
    this.sendAnalyticsEvent("copy-link", i);
  }
  async _handleCopyLink() {
    this.pending = !0;
    try {
      const i = this.bookmarkId ? f(this.bookmarkId) : _(this.libraryName, this._getAssetsStoragePath(), !this.copyDisabled, !this.followDisabled).catch((t) => t.status === 409 ? I(this._getAssetsStoragePath()) : Promise.reject(t));
      return this._sendCopyLinkAnalytics(), this._copyToClipboard(i);
    } catch (i) {
      this._dispatchErrorNotification(), this.handleApiError(i, "libraries");
    } finally {
      this.pending = !1;
    }
  }
  _copyToClipboard(i) {
    var n;
    const t = i.then((a) => {
      var o;
      this._handleSuccessLinkGeneration(a);
      const h = (o = a.bookmarkURL) == null ? void 0 : o.split("/").pop();
      return new Blob([`${window.location.origin}/libraries/${h}`], { type: "text/plain" });
    });
    return (n = navigator.clipboard) == null ? void 0 : n.write([new ClipboardItem({ "text/plain": t })]).then(() => {
      this.dispatchSuccessNotification(this.t("share-library-dialog.success-message")), this._handleClose();
    }).catch((a) => {
      u() || console.error("Failed to copy to clipboard", a), this._dispatchErrorNotification();
    });
  }
  _handleSuccessLinkGeneration(i) {
    var t;
    this.bookmarkId = i.bookmarkId, this.publicId = (t = i.bookmarkURL) == null ? void 0 : t.split("/").pop(), this.creatorId = i.creatorId, this._dispatchSavePublicLibraryUrlEvent();
  }
  _dispatchErrorNotification() {
    this.dispatchEvent(new c({ type: "error", message: this.t("share-library-dialog.error-message") }));
  }
  _getAssetsStoragePath() {
    return this.storagePath.substring(this.storagePath.indexOf("/assets"));
  }
  dispatchSuccessNotification(i) {
    this.dispatchEvent(new c({ type: "success", message: i }));
  }
  _dispatchSavePublicLibraryUrlEvent() {
    this.dispatchEvent(new L({ bookmarkId: this.bookmarkId, shareableId: this.publicId, privateId: this.libraryIdOrUrn, creatorId: this.creatorId, allowCopy: !this.copyDisabled, allowFollow: !this.followDisabled }));
  }
  async _removeCopyLink() {
    try {
      if (!this.bookmarkId) return;
      await C(this.bookmarkId), this.dispatchEvent(new $({ libraryId: this.libraryIdOrUrn })), this.showLinkRemovalMessage = !0, this.bookmarkId = null, this.sendAnalyticsEvent("remove-public-link", {});
    } catch (i) {
      this.dispatchEvent(new c({ type: "error", message: this.t("share-library-dialog.removal-error-message") })), this.handleApiError(i, "libraries");
    }
  }
  async _updateLinkSettings() {
    try {
      if (!this.bookmarkId) return;
      await S(this.libraryName, this.bookmarkId, !this.copyDisabled, !this.followDisabled), this._dispatchSuccessfulUpdateEvents();
    } catch (i) {
      throw this.dispatchEvent(new c({ type: "error", message: this.t("share-library-dialog.update-error-message") })), i;
    }
  }
};
s([l({ type: Boolean })], e.prototype, "open", 2), s([l()], e.prototype, "libraryIdOrUrn", 2), s([l()], e.prototype, "libraryName", 2), s([l()], e.prototype, "storagePath", 2), s([l({ type: Boolean })], e.prototype, "copyDisabled", 2), s([l({ type: Boolean })], e.prototype, "followDisabled", 2), s([l()], e.prototype, "bookmarkId", 2), s([l()], e.prototype, "publicId", 2), s([l()], e.prototype, "creatorId", 2), s([d()], e.prototype, "showLinkRemovalMessage", 2), s([d()], e.prototype, "pending", 2), e = s([g("af-share-library-dialog")], e);
const si = e;
export {
  si as default
};
//# sourceMappingURL=ShareLibraryDialog.js.map
